var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 0C18.9524 0 14.3848 1.38558 10.4997 3.98153C6.61455 6.57748 3.58648 10.2672 1.79836 14.5841C0.0102363 18.901 -0.457617 23.6512 0.453958 28.234C1.36553 32.8168 3.6156 37.0264 6.91961 40.3304C10.2236 43.6344 14.4332 45.8845 19.016 46.796C23.5988 47.7076 28.349 47.2398 32.6659 45.4516C36.9828 43.6635 40.6725 40.6355 43.2685 36.7503C45.8644 32.8652 47.25 28.2976 47.25 23.625C47.25 17.3593 44.7609 11.3501 40.3304 6.9196C35.8999 2.48905 29.8907 0 23.625 0ZM36.1918 25.1353L15.9418 35.2603C15.6845 35.3889 15.3985 35.4496 15.1112 35.4366C14.8238 35.4235 14.5445 35.3373 14.2998 35.1859C14.0552 35.0346 13.8533 34.8233 13.7133 34.5719C13.5733 34.3206 13.4999 34.0377 13.5 33.75V13.5C13.5002 13.2125 13.5738 12.9297 13.7139 12.6786C13.854 12.4276 14.0559 12.2164 14.3006 12.0653C14.5452 11.9142 14.8243 11.828 15.1116 11.8151C15.3988 11.8022 15.6846 11.8628 15.9418 11.9914L36.1918 22.1164C36.4717 22.2567 36.7071 22.4721 36.8716 22.7385C37.0361 23.0049 37.1232 23.3119 37.1232 23.625C37.1232 23.9381 37.0361 24.2451 36.8716 24.5115C36.7071 24.7779 36.4717 24.9933 36.1918 25.1336",
    fill: "#367FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayButton);
export default __webpack_public_path__ + "static/media/icon-play-button.62ec093db2b49c31505f2fbb7ce877db.svg";
export { ForwardRef as ReactComponent };